import { Box } from '@mui/material';
import React from 'react'

const CardContainer = ({ children }) => {
  return (
    <Box
      sx={{
        margin: "1.5rem auto 0",
        width: "95%",
        maxWidth: "1000px",
        background: "white",
        minHeight: "85vh",
        borderRadius: "8px",
        padding: "0 1rem",
      }}
    >
      {children}
    </Box>
  );
};

export default CardContainer